export type UfosRecord = Record<string, unknown>;

export interface UfosResponse<T> {
  ok: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface UfosSource {
  label: string;
  last_seen_at?: string | null;
  last_source_capture_at?: string | null;
  checkpoints?: UfosRecord[];
}

export interface UfosLoad {
  record: UfosRecord;
  customer_freight: { amount: unknown; currency: unknown; source: string };
  customer_charges: UfosRecord[];
  carrier_costs: UfosRecord[];
}

export interface UfosTable {
  name: string;
  label: string;
  group: string;
}

export interface UfosOverview {
  lading_uuid: string;
  matched: boolean;
  source: UfosSource;
  orders: UfosRecord[];
  loads: UfosLoad[];
  contacts: Record<string, UfosRecord[]>;
  references: Record<string, UfosRecord[]>;
  documents: Record<string, UfosRecord[]>;
  tables: UfosTable[];
  warnings: string[];
  truncated_tables: string[];
}

export interface UfosRecordPage {
  table: string;
  rows: UfosRecord[];
  offset: number;
  limit: number;
  has_more: boolean;
}

// UI visibility only. The PHP bridge and Glebus independently enforce access.
export function canViewUfosUser(userId: number | undefined): boolean {
  return userId !== undefined && [1, 20, 22, 107].includes(userId);
}
